import { Reducer, createSlice } from "@reduxjs/toolkit";
import { AppDispatch } from "../state";
import { SERVER_URL } from "../../utils/server";
import { Callback } from "../../index.d";
import { User } from "./authSlice";
import { toggleSessionExpired } from "../utils/uiSlice";
import { pageSizeReq } from "../../utils/constants";

export type Tache = {
  [index: string]: any;
  dateCreation?: string;
  dateModification?: string;
  libelle?: string;
  typeProfil?: string;
  statutTache?: string;
  infosBadge?: any;
  infosOffre?: any;
  infosRealisation?: any;
  infosTransaction?: any;
  nomAdminUtilisateur?: string;
  prenomAdminUtilisateur?: string;
  idAdminUtilisateur?: number;
};

export declare interface TacheState {
  [index: string]: any;
}
const initialState: TacheState = {};

export const tacheSlice = createSlice({
  initialState,
  name: "tache",
  reducers: {
    createTache: (state, action) => {
      state[action.payload.id] = action.payload;
      return state;
    },
    listTache: (state, action) => {
      for (const obj of action.payload) {
        state[obj.id] = obj;
      }
      return state;
    },
    removeTache: (state, action) => {
      delete state[action.payload];
      return state;
    },
    updateTache: (state, action) => {
      state[action.payload.id] = {
        ...state[action.payload.id],
        ...action.payload,
      };
      return state;
    },
  },
});

export const {
  createTache,
  listTache,
  removeTache,
  updateTache,
} = tacheSlice.actions;

export const createAsyncTache =
  (data: Tache, callback: Callback, onError: Callback) =>
  async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;
      const result = await fetch(`${SERVER_URL}tache`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
      });

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      if (result.status === 201) {
        dispatch(listAsyncTache());
        callback?.();
      } else {
        onError?.();
      }
    } catch (error) {
      console.log("create tache error", error);
      onError?.();
    }
  };

export const listAsyncTache =
  () => async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;

      const result = await fetch(
        `${SERVER_URL}tache?size=${pageSizeReq}&page=1`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      const res = await result.json();
      if (res.data.length) {
        dispatch(listTache(res.data));
      }
    } catch (error) {
      console.log("list tache error", error);
      // onError?.();
    }
  };

export default tacheSlice.reducer as Reducer<TacheState>;
